import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BusinessCalendarComponent } from 'src/app/pages/business-calendar/business-calendar.component';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';

const routes: Routes = [
  {
    path: '',
    component: BusinessCalendarComponent,
    canActivate: [AuthenticationService],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessCalendarRoutingModule { }
